import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import { forwardRef } from 'react';

export const MenuIcon = forwardRef<SVGSVGElement, SvgIconProps>(function MenuIcon(props, ref) {
  return (
    <SvgIcon ref={ref} data-testid="MenuIcon" {...props}>
      <path d="M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z" />
    </SvgIcon>
  );
});
